import { useCreateTypeLinkMutation } from "../../api/api-hooks";
import { AnalyzerLinksForm } from "./linksTypes";

const useAnalyzerLinksCreator = () => {
  const [createLink] = useCreateTypeLinkMutation();
  return (item: AnalyzerLinksForm) => {
    if (
      item.hardwareType === null ||
      item.hardwareType === undefined ||
      !item.name ||
      !item.link
    )
      return { error: { data: { message: "Missing required fields" } } };
    return createLink({
      createHardwareTypeLinkDto: {
        name: item.name,
        link: item.link,
        hardwareTypeId: item.hardwareType.id,
      },
    });
  };
};

export default useAnalyzerLinksCreator;
